import { takeEvery, put, call } from "redux-saga/effects"

//Account Redux states
import { ACTIVATE_USER, REGISTER_USER, USER_ACTIVATE } from "./actionTypes"
import {
  registerUserSuccessful,
  registerUserFailed,
  activateUserSuccess,
  activateUserFail,
} from "./actions"

import { activateUser, postJwtRegister1 } from "../../../helpers/backend_helper"
import { isEmpty } from "lodash"

// Is user register successfull then direct plot user in redux.
function* registerUser({ payload: { user, history } }) {
  try {
    const response = yield call(postJwtRegister1, user)
    yield put(registerUserSuccessful(response))
    history.push({
      pathname: "/email-verification",
      email: user.email,
    })
    console.log("response")
    console.log(response)
  } catch (error) {
    if (!isEmpty(error.response) && !isEmpty(error.response.data)) {
      yield put(registerUserFailed(error.response.data))
    } else {
      yield put(registerUserFailed(error.message))
    }
  }
}

function* activateUserSaga({ token }) {
  try {
    // const response = yield call(activateUser, { token: token })
    const response = yield call(activateUser, token)
    yield put(activateUserSuccess(response))
  } catch (error) {
    yield put(activateUserFail(error.response))
  }
}

function* accountSaga() {
  yield takeEvery(REGISTER_USER, registerUser)
  yield takeEvery(ACTIVATE_USER, activateUserSaga)
}

export default accountSaga
